export const DynamicChannelIcon = {
  facebook_like_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12038"
            fill="#fff"
            stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            d="M0 0h16v16H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 341" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path data-name="Rectangle 12039" fill="none" d="M0 0h16v16H0z" />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15950"
              d="M12.667 5.667h-2.334l.133-1.1c.2-1.633-.133-2.933-1.2-3.233h-.1a.667.667 0 0 0-.5.4S6.333 6.667 5.333 6.667H1.667A.667.667 0 0 0 1 7.333v5.333a.667.667 0 0 0 .667.667H6.1a.533.533 0 0 1 .4.133 7.292 7.292 0 0 0 2.833 1.2H11c1.967 0 3.667-1.333 3.833-3.967L15 8a2.233 2.233 0 0 0-2.333-2.333zM2.333 8h2v4h-2zM13.5 10.6c-.133 1.733-1.067 2.733-2.5 2.733H9.333A7.33 7.33 0 0 1 7.3 12.4a1.933 1.933 0 0 0-1.2-.4h-.433V8c.633-.133 1.667-.733 3.5-4.267a5.4 5.4 0 0 1-.033.7L9 5.533 8.833 7h3.833a.9.9 0 0 1 1 .967z"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  facebook_like: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.315" height="16">
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12038"
            fill="#2d3e5c"
            stroke="#707070"
            d="M0 0h15.315v16H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 341" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              data-name="Rectangle 12039"
              fill="none"
              d="M0 0h15.315v16H0z"
            />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15950"
              d="M12.124 5.667H9.891l.128-1.1c.191-1.633-.128-2.933-1.149-3.233h-.1a.644.644 0 0 0-.479.4S6.062 6.667 5.105 6.667h-3.51a.653.653 0 0 0-.638.666v5.333a.653.653 0 0 0 .638.667h4.244a.5.5 0 0 1 .383.133 6.827 6.827 0 0 0 2.712 1.2h1.6c1.883 0 3.51-1.333 3.669-3.967L14.357 8a2.289 2.289 0 0 0-.624-1.682 2.089 2.089 0 0 0-1.61-.652ZM2.233 8h1.915v4H2.233Zm10.689 2.6c-.128 1.733-1.021 2.733-2.393 2.733h-1.6a6.878 6.878 0 0 1-1.942-.933 1.8 1.8 0 0 0-1.148-.4h-.415V8c.606-.133 1.6-.733 3.35-4.267a5.639 5.639 0 0 1-.032.7l-.128 1.1L8.457 7h3.669a.839.839 0 0 1 .7.247.923.923 0 0 1 .26.72Z"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  upvote: (
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
    >
      <g data-name="invisible box">
        <path data-name="Rectangle 140737" fill="none" d="M0 0h19v19H0z" />
      </g>
      <g data-name="Q3 icons">
        <path
          data-name="Path 48198"
          d="m9.5 3.642 5.344 6.008h-3.8v5.926H7.956V9.65h-3.8L9.5 3.642m0-2.058a.853.853 0 0 0-.594.247L1.821 9.856a.845.845 0 0 0-.212.924.791.791 0 0 0 .766.517h4v5.1a.808.808 0 0 0 .792.823h4.664a.808.808 0 0 0 .8-.821v-5.1h4a.791.791 0 0 0 .766-.517.845.845 0 0 0-.212-.924l-7.092-8.027a.853.853 0 0 0-.593-.247Z"
          fill="var(--nonactionable-icon-color,#3b5175)"
        />
      </g>
    </svg>
  ),
  upvote_white: (
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
    >
      <g data-name="invisible box">
        <path data-name="Rectangle 140737" fill="none" d="M0 0h19v19H0z" />
      </g>
      <g data-name="Q3 icons">
        <path
          data-name="Path 48198"
          d="m9.5 3.642 5.344 6.008h-3.8v5.926H7.956V9.65h-3.8L9.5 3.642m0-2.058a.853.853 0 0 0-.594.247L1.821 9.856a.845.845 0 0 0-.212.924.791.791 0 0 0 .766.517h4v5.1a.808.808 0 0 0 .792.823h4.664a.808.808 0 0 0 .8-.821v-5.1h4a.791.791 0 0 0 .766-.517.845.845 0 0 0-.212-.924l-7.092-8.027a.853.853 0 0 0-.593-.247Z"
          fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        />
      </g>
    </svg>
  ),
  facebook_share: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.315" height="15.315">
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12040"
            fill="#2d3e5c"
            stroke="#707070"
            d="M0 0h15.315v15.315H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 342" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              data-name="Rectangle 12041"
              fill="none"
              d="M0 0h15.315v16H0z"
            />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15951"
              d="M11.806 9.333a2.453 2.453 0 0 0-2.01 1.033L5.393 8.4a1.7 1.7 0 0 0 .031-.4 1.7 1.7 0 0 0-.032-.4l4.4-1.967a2.453 2.453 0 0 0 2.01 1.033A2.611 2.611 0 0 0 14.358 4a2.555 2.555 0 1 0-5.105 0 1.7 1.7 0 0 0 .032.4L4.886 6.367a2.453 2.453 0 0 0-2.01-1.033A2.611 2.611 0 0 0 .319 8a2.611 2.611 0 0 0 2.553 2.667 2.453 2.453 0 0 0 2.014-1.034l4.4 1.967a1.7 1.7 0 0 0-.032.4 2.555 2.555 0 1 0 2.552-2.667Zm0-6.667A1.306 1.306 0 0 1 13.086 4a1.277 1.277 0 1 1-2.553 0 1.306 1.306 0 0 1 1.273-1.333ZM2.872 9.333a1.335 1.335 0 0 1 0-2.667 1.335 1.335 0 0 1 0 2.667Zm8.934 4A1.335 1.335 0 1 1 13.086 12a1.306 1.306 0 0 1-1.28 1.333Z"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  facebook_share_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.315" height="15.315">
      <defs>
        <clipPath id="a">
          <path
            data-name="Rectangle 12040"
            fill="#fff"
            stroke="var(--locobuzz-primary-bg-color,#707070)"
            d="M0 0h15.315v15.315H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Mask Group 342" clipPath="url(#a)">
        <g data-name="Layer 2">
          <g data-name="invisible box">
            <path
              data-name="Rectangle 12041"
              fill="none"
              d="M0 0h15.315v16H0z"
            />
          </g>
          <g data-name="icons Q2">
            <path
              data-name="Path 15951"
              d="M11.806 9.333a2.453 2.453 0 0 0-2.01 1.033L5.393 8.4a1.7 1.7 0 0 0 .031-.4 1.7 1.7 0 0 0-.032-.4l4.4-1.967a2.453 2.453 0 0 0 2.01 1.033A2.611 2.611 0 0 0 14.358 4a2.555 2.555 0 1 0-5.105 0 1.7 1.7 0 0 0 .032.4L4.886 6.367a2.453 2.453 0 0 0-2.01-1.033A2.611 2.611 0 0 0 .319 8a2.611 2.611 0 0 0 2.553 2.667 2.453 2.453 0 0 0 2.014-1.034l4.4 1.967a1.7 1.7 0 0 0-.032.4 2.555 2.555 0 1 0 2.552-2.667Zm0-6.667A1.306 1.306 0 0 1 13.086 4a1.277 1.277 0 1 1-2.553 0 1.306 1.306 0 0 1 1.273-1.333ZM2.872 9.333a1.335 1.335 0 0 1 0-2.667 1.335 1.335 0 0 1 0 2.667Zm8.934 4A1.335 1.335 0 1 1 13.086 12a1.306 1.306 0 0 1-1.28 1.333Z"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))" //"#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  instagram_share: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.797"
      height="11.811"
      viewBox="0 0 11.797 11.811"
    >
      <g id="Insta_share" transform="translate(-6.021 -5.998)">
        <path
          id="Path_59997"
          data-name="Path 59997"
          d="M17.682,6.141a.492.492,0,0,0-.517-.113L6.34,9.965a.492.492,0,0,0,0,.92l4.724,1.89,1.89,4.724a.475.475,0,0,0,.9-.015L17.785,6.658A.492.492,0,0,0,17.682,6.141Zm-4.286,9.8-1.373-3.445,2.357-2.357-.694-.694L11.309,11.82,7.885,10.427l8.626-3.115Z"
          transform="translate(0 0)"
          fill="var(--nonactionable-icon-color,#2d3e5c)"
        />
      </g>
    </svg>
  ),
  instagram_share_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.797"
      height="11.811"
      viewBox="0 0 11.797 11.811"
    >
      <g id="Insta_share" transform="translate(-6.021 -5.998)">
        <path
          id="Path_59997"
          data-name="Path 59997"
          d="M17.682,6.141a.492.492,0,0,0-.517-.113L6.34,9.965a.492.492,0,0,0,0,.92l4.724,1.89,1.89,4.724a.475.475,0,0,0,.9-.015L17.785,6.658A.492.492,0,0,0,17.682,6.141Zm-4.286,9.8-1.373-3.445,2.357-2.357-.694-.694L11.309,11.82,7.885,10.427l8.626-3.115Z"
          transform="translate(0 0)"
          fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        />
      </g>
    </svg>
  ),
  youtube_share: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.37" height="11.329">
      <path
        d="M12.761 4.828 8.218.578a.232.232 0 0 0-.18-.077c-.142.006-.322.106-.322.258V2.89a.138.138 0 0 1-.116.132c-4.519.692-6.422 4.073-7.099 7.583-.026.138.161.267.248.158a8.213 8.213 0 0 1 6.826-3.459.159.159 0 0 1 .135.154v2.093a.277.277 0 0 0 .467.171l4.576-4.325a.356.356 0 0 0 .113-.271.431.431 0 0 0-.109-.3Z"
        fill="none"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
      />
    </svg>
  ),
  youtube_share_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.37" height="11.329">
      <path
        d="M12.761 4.828 8.218.578a.232.232 0 0 0-.18-.077c-.142.006-.322.106-.322.258V2.89a.138.138 0 0 1-.116.132c-4.519.692-6.422 4.073-7.099 7.583-.026.138.161.267.248.158a8.213 8.213 0 0 1 6.826-3.459.159.159 0 0 1 .135.154v2.093a.277.277 0 0 0 .467.171l4.576-4.325a.356.356 0 0 0 .113-.271.431.431 0 0 0-.109-.3Z"
        fill="none"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
      />
    </svg>
  ),
  video_view: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color,#2d3e5c)">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  video_view_white: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  like_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
      <path d="M0 0h15v15H0z" style={{ fill: "none" }} />
      <path
        d="M15.239 3.738a4.361 4.361 0 0 0-5.743.82 4.353 4.353 0 0 0-5.743-.82A4.074 4.074 0 0 0 2 6.937c-.1 2.893 2.474 5.212 6.41 8.768l.075.067a1.5 1.5 0 0 0 2.017-.007l.082-.075c3.936-3.549 6.507-5.868 6.41-8.761a4.072 4.072 0 0 0-1.755-3.191zM9.571 14.594l-.075.075-.075-.075C5.852 11.38 3.5 9.255 3.5 7.1a2.555 2.555 0 0 1 2.624-2.61A2.931 2.931 0 0 1 8.8 6.251h1.4a2.913 2.913 0 0 1 2.669-1.76A2.555 2.555 0 0 1 15.494 7.1c0 2.155-2.355 4.28-5.923 7.494z"
        transform="translate(-1.996 -2.193)"
        style={{ fill: "var(--nonactionable-icon-color,#2d3e5c)" }}
      />
    </svg>
  ),
  like_white_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
      <path d="M0 0h15v15H0z" style={{ fill: "none" }} />
      <path
        d="M15.239 3.738a4.361 4.361 0 0 0-5.743.82 4.353 4.353 0 0 0-5.743-.82A4.074 4.074 0 0 0 2 6.937c-.1 2.893 2.474 5.212 6.41 8.768l.075.067a1.5 1.5 0 0 0 2.017-.007l.082-.075c3.936-3.549 6.507-5.868 6.41-8.761a4.072 4.072 0 0 0-1.755-3.191zM9.571 14.594l-.075.075-.075-.075C5.852 11.38 3.5 9.255 3.5 7.1a2.555 2.555 0 0 1 2.624-2.61A2.931 2.931 0 0 1 8.8 6.251h1.4a2.913 2.913 0 0 1 2.669-1.76A2.555 2.555 0 0 1 15.494 7.1c0 2.155-2.355 4.28-5.923 7.494z"
        transform="translate(-1.996 -2.193)"
        style={{
          fill: "var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))",
        }}
      />
    </svg>
  ),
  comment_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.608" height="14.045">
      <path
        d="M6.783 16.727a.46.46 0 0 1-.212 0 .472.472 0 0 1-.236-.483v-2.357a3.442 3.442 0 0 1-2.982-3.395V6.613a3.43 3.43 0 0 1 3.43-3.418h6.247a3.43 3.43 0 0 1 3.43 3.418v3.878a3.43 3.43 0 0 1-3.43 3.418h-2.581l-3.36 2.711a.507.507 0 0 1-.306.107zm-.036-12.66a2.523 2.523 0 0 0-2.534 2.546v3.878a2.523 2.523 0 0 0 2.534 2.523.448.448 0 0 1 .448.448V15.4L10 13.132a.507.507 0 0 1 .318-.118h2.676a2.523 2.523 0 0 0 2.534-2.523V6.613a2.523 2.523 0 0 0-2.534-2.546z"
        transform="translate(-3.103 -2.945)"
        style={{
          fill: "var(--nonactionable-icon-color,#2d3e5c)",
          stroke: "var(--nonactionable-icon-color,#2d3e5c)",
          strokeWidth: ".5px",
        }}
      />
    </svg>
  ),
  comment_white_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="15.608" height="14.045">
      <path
        d="M6.783 16.727a.46.46 0 0 1-.212 0 .472.472 0 0 1-.236-.483v-2.357a3.442 3.442 0 0 1-2.982-3.395V6.613a3.43 3.43 0 0 1 3.43-3.418h6.247a3.43 3.43 0 0 1 3.43 3.418v3.878a3.43 3.43 0 0 1-3.43 3.418h-2.581l-3.36 2.711a.507.507 0 0 1-.306.107zm-.036-12.66a2.523 2.523 0 0 0-2.534 2.546v3.878a2.523 2.523 0 0 0 2.534 2.523.448.448 0 0 1 .448.448V15.4L10 13.132a.507.507 0 0 1 .318-.118h2.676a2.523 2.523 0 0 0 2.534-2.523V6.613a2.523 2.523 0 0 0-2.534-2.546z"
        transform="translate(-3.103 -2.945)"
        style={{
          fill: "var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))",
          stroke:
            "var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))",
          strokeWidth: ".5px",
        }}
      />
    </svg>
  ),
  postClick_white: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.553"
      height="16.439"
      viewBox="0 0 16.553 16.439"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(-0.01 -0.084)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0.01 0.084)">
          <g id="Layer_1-2" data-name="Layer 1-2">
            <path
              id="Path_59909"
              data-name="Path 59909"
              d="M16.881,14.873l-2.77-2.77,1.974-1.144a.474.474,0,0,0,.237-.432.491.491,0,0,0-.3-.4L7.216,6.614a.457.457,0,0,0-.6.271.449.449,0,0,0,0,.33l3.515,8.81a.44.44,0,0,0,.4.3.457.457,0,0,0,.432-.237L12.1,14.111l2.77,2.77a.46.46,0,0,0,.652,0l1.355-1.347a.474.474,0,0,0,0-.661Z"
              transform="translate(-1.015 -1.077)"
              fill="none"
              stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="Path_59910"
              data-name="Path 59910"
              d="M3.265,2.458a.6.6,0,1,0-.847.847L3.731,4.585a.6.6,0,1,0,.847-.847Z"
              transform="translate(-0.351 -0.42)"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            />
            <path
              id="Path_59911"
              data-name="Path 59911"
              d="M2.788,8.352a.542.542,0,0,0-.542-.542H.552a.542.542,0,1,0,0,1.084H2.246a.534.534,0,0,0,.542-.534Z"
              transform="translate(-0.01 -1.265)"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            />
            <path
              id="Path_59912"
              data-name="Path 59912"
              d="M3.3,11.708l-1.33,1.321a.6.6,0,0,0,.847.847l1.321-1.321a.6.6,0,0,0,0-.847.584.584,0,0,0-.839,0Z"
              transform="translate(-0.283 -1.834)"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            />
            <path
              id="Path_59913"
              data-name="Path 59913"
              d="M8.351,2.808a.542.542,0,0,0,.542-.534h0V.58A.551.551,0,0,0,7.8.555h0V2.249a.551.551,0,0,0,.551.559Z"
              transform="translate(-1.201 -0.084)"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            />
            <path
              id="Path_59914"
              data-name="Path 59914"
              d="M12.235,4.2a.491.491,0,0,0,.364-.152l1.152-1.152a.508.508,0,0,0,0-.72h0a.508.508,0,0,0-.728,0L11.862,3.307a.508.508,0,0,0,0,.729A.491.491,0,0,0,12.235,4.2Z"
              transform="translate(-1.799 -0.38)"
              fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  postClick_black: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.553"
      height="16.439"
      viewBox="0 0 16.553 16.439"
    >
      <g id="Layer_2" data-name="Layer 2" transform="translate(-0.01 -0.084)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0.01 0.084)">
          <g id="Layer_1-2" data-name="Layer 1-2">
            <path
              id="Path_59909"
              data-name="Path 59909"
              d="M16.881,14.873l-2.77-2.77,1.974-1.144a.474.474,0,0,0,.237-.432.491.491,0,0,0-.3-.4L7.216,6.614a.457.457,0,0,0-.6.271.449.449,0,0,0,0,.33l3.515,8.81a.44.44,0,0,0,.4.3.457.457,0,0,0,.432-.237L12.1,14.111l2.77,2.77a.46.46,0,0,0,.652,0l1.355-1.347a.474.474,0,0,0,0-.661Z"
              transform="translate(-1.015 -1.077)"
              fill="none"
              stroke="var(--nonactionable-icon-color,#2d3e5c)"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="Path_59910"
              data-name="Path 59910"
              d="M3.265,2.458a.6.6,0,1,0-.847.847L3.731,4.585a.6.6,0,1,0,.847-.847Z"
              transform="translate(-0.351 -0.42)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59911"
              data-name="Path 59911"
              d="M2.788,8.352a.542.542,0,0,0-.542-.542H.552a.542.542,0,1,0,0,1.084H2.246a.534.534,0,0,0,.542-.534Z"
              transform="translate(-0.01 -1.265)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59912"
              data-name="Path 59912"
              d="M3.3,11.708l-1.33,1.321a.6.6,0,0,0,.847.847l1.321-1.321a.6.6,0,0,0,0-.847.584.584,0,0,0-.839,0Z"
              transform="translate(-0.283 -1.834)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59913"
              data-name="Path 59913"
              d="M8.351,2.808a.542.542,0,0,0,.542-.534h0V.58A.551.551,0,0,0,7.8.555h0V2.249a.551.551,0,0,0,.551.559Z"
              transform="translate(-1.201 -0.084)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
            <path
              id="Path_59914"
              data-name="Path 59914"
              d="M12.235,4.2a.491.491,0,0,0,.364-.152l1.152-1.152a.508.508,0,0,0,0-.72h0a.508.508,0,0,0-.728,0L11.862,3.307a.508.508,0,0,0,0,.729A.491.491,0,0,0,12.235,4.2Z"
              transform="translate(-1.799 -0.38)"
              fill="var(--nonactionable-icon-color,#2d3e5c)"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  delete_post: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Delete">
        <path
          id="Vector"
          d="M4.87504 7.62055L5.12504 15.1874C5.14634 15.8355 5.41934 16.4497 5.8861 16.8998C6.35286 17.3499 6.97664 17.6004 7.62504 17.5981H12.375C13.023 17.6004 13.6464 17.3503 14.1131 16.9007C14.5798 16.4512 14.8531 15.8375 14.875 15.1899L15.125 7.62055C15.1305 7.45479 15.0699 7.29365 14.9566 7.17257C14.8432 7.05149 14.6864 6.9804 14.5207 6.97493C14.3549 6.96946 14.1938 7.03006 14.0727 7.1434C13.9516 7.25674 13.8805 7.41354 13.875 7.5793L13.625 15.1481C13.6126 15.4712 13.4754 15.7769 13.2423 16.001C13.0093 16.2251 12.6984 16.3502 12.375 16.3499H7.62504C7.30128 16.3501 6.99006 16.2247 6.75691 16.0001C6.52376 15.7754 6.38686 15.4691 6.37504 15.1456L6.12504 7.5793C6.11957 7.41354 6.04848 7.25674 5.9274 7.1434C5.80632 7.03006 5.64518 6.96946 5.47942 6.97493C5.31366 6.9804 5.15686 7.05149 5.04352 7.17257C4.93018 7.29365 4.86957 7.45479 4.87504 7.62055ZM4.04817 5.10243C4.04817 5.26819 4.11402 5.42716 4.23123 5.54437C4.34844 5.66158 4.50741 5.72743 4.67317 5.72743H15.3263C15.4921 5.72743 15.651 5.66158 15.7682 5.54437C15.8854 5.42716 15.9513 5.26819 15.9513 5.10243C15.9513 4.93667 15.8854 4.7777 15.7682 4.66049C15.651 4.54328 15.4921 4.47743 15.3263 4.47743H13.3888C13.1908 4.47796 12.9996 4.4048 12.8526 4.27218C12.7055 4.13955 12.613 3.95696 12.5932 3.75993C12.547 3.29773 12.3305 2.86926 11.9857 2.558C11.641 2.24673 11.1927 2.07497 10.7282 2.07618H9.27192C8.80743 2.07497 8.35912 2.24673 8.01435 2.558C7.66958 2.86926 7.45304 3.29773 7.40692 3.75993C7.38705 3.95696 7.29459 4.13955 7.14753 4.27218C7.00047 4.4048 6.80932 4.47796 6.61129 4.47743H4.67379C4.50803 4.47743 4.34906 4.54328 4.23185 4.66049C4.11464 4.7777 4.04879 4.93667 4.04879 5.10243H4.04817ZM11.5082 4.47743H8.49067C8.5728 4.28977 8.62651 4.09092 8.65004 3.88743C8.66553 3.73337 8.73764 3.59054 8.85242 3.48662C8.9672 3.3827 9.11646 3.32508 9.27129 3.32493H10.7275C10.8824 3.32508 11.0316 3.3827 11.1464 3.48662C11.2612 3.59054 11.3333 3.73337 11.3488 3.88743C11.3725 4.09095 11.4258 4.2898 11.5082 4.47743ZM10.8788 13.9468V8.62493C10.8788 8.45917 10.9446 8.3002 11.0619 8.18299C11.1791 8.06578 11.338 7.99993 11.5038 7.99993C11.6696 7.99993 11.8285 8.06578 11.9457 8.18299C12.0629 8.3002 12.1288 8.45917 12.1288 8.62493V13.9493C12.1288 14.1151 12.0629 14.274 11.9457 14.3912C11.8285 14.5085 11.6696 14.5743 11.5038 14.5743C11.338 14.5743 11.1791 14.5085 11.0619 14.3912C10.9446 14.274 10.8788 14.1151 10.8788 13.9493V13.9468ZM7.87004 13.9468V8.62493C7.87004 8.45917 7.93589 8.3002 8.0531 8.18299C8.17031 8.06578 8.32928 7.99993 8.49504 7.99993C8.6608 7.99993 8.81978 8.06578 8.93699 8.18299C9.0542 8.3002 9.12004 8.45917 9.12004 8.62493V13.9493C9.12004 14.1151 9.0542 14.274 8.93699 14.3912C8.81978 14.5085 8.6608 14.5743 8.49504 14.5743C8.32928 14.5743 8.17031 14.5085 8.0531 14.3912C7.93589 14.274 7.87004 14.1151 7.87004 13.9493V13.9468Z"
          fill="#FF5D48" //"#FF5D48" //
        />
      </g>
    </svg>
  ),
  hide_post: (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="hidden" clipPath="url(#clip0_1299_1105)">
        <g id="Layer 2">
          <g id="Layer 1">
            <path
              id="Vector"
              d="M7.99995 2.63596C9.33752 2.63011 10.6494 3.00125 11.7841 3.7065C12.9188 4.41174 13.83 5.4223 14.4122 6.62139C13.991 7.48686 13.3941 8.25591 12.6591 8.87996L13.7034 9.90102C14.728 9.00272 15.5219 7.87338 16.0189 6.60728C15.2126 4.57974 13.6614 2.93386 11.6805 2.00397C9.69963 1.07408 7.43754 0.929926 5.35376 1.60078L6.554 2.79594C7.02945 2.69496 7.51383 2.64137 7.99995 2.63596Z"
              fill="var(--nonactionable-icon-color,#F0C52F)"
            />
            <path
              id="Vector_2"
              d="M7.22032 3.46416L8.7277 4.96046L9.67277 5.90153L11.1754 7.40254C11.3032 6.92194 11.3175 6.4184 11.2171 5.9314C11.1167 5.4444 10.9043 4.98719 10.5967 4.59561C10.289 4.20404 9.8945 3.88876 9.44397 3.67449C8.99345 3.46022 8.49921 3.3528 8 3.36064C7.73673 3.36173 7.47468 3.39652 7.22032 3.46416ZM0.732428 1.09737L2.68399 3.03597C1.4829 3.97011 0.555921 5.20843 0 6.62145C0.833484 8.73414 2.47562 10.4306 4.56519 11.3378C6.65475 12.2449 9.02061 12.2883 11.1424 11.4585L13.6279 13.9336L14.6486 12.9125L1.75783 0.0668945L0.732428 1.09737ZM3.71412 4.06644L4.98996 5.33218C4.81318 5.73247 4.72301 6.16534 4.72534 6.60263C4.72396 7.13817 4.85602 7.66569 5.1097 8.13792C5.36338 8.61015 5.73076 9.01233 6.1789 9.30842C6.62704 9.60452 7.14195 9.78529 7.67749 9.83452C8.21304 9.88375 8.75248 9.79992 9.24749 9.59052L9.27584 9.61876L9.98937 10.3293C9.33833 10.5087 8.66607 10.6005 7.99055 10.6022C6.655 10.6042 5.34582 10.232 4.21271 9.52805C3.0796 8.8241 2.16829 7.81684 1.58299 6.62145C2.08278 5.61544 2.81273 4.7403 3.71412 4.06644Z"
              fill="var(--nonactionable-icon-color,#F0C52F)"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1299_1105">
          <rect
            width="16"
            height="13.8667"
            fill="white"
            transform="translate(0 0.0668945)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  //"#6a8eff"
  deep_link_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15.56"
      viewBox="-1 0 17.65 13.55"
    >
      <path
        data-name="carnet (1)"
        d="M13.827 1.224H9.562a1.836 1.836 0 0 0-3.461 0H1.836A1.838 1.838 0 0 0 0 3.059v8.657a1.838 1.838 0 0 0 1.836 1.835h11.993a1.838 1.838 0 0 0 1.834-1.835V3.059a1.838 1.838 0 0 0-1.836-1.835Zm-6 0a.612.612 0 1 1-.612.612.613.613 0 0 1 .616-.612Zm6.608 10.493a.613.613 0 0 1-.611.612H1.836a.613.613 0 0 1-.612-.612V3.059a.613.613 0 0 1 .612-.612H6.1a1.835 1.835 0 0 0 3.461 0h4.266a.613.613 0 0 1 .612.612Zm-4.8-5.782h3.61v1.224H9.636Zm0 2.478h3.61v1.224H9.636ZM7.044 8a1.927 1.927 0 1 0-3.117.025 3.06 3.06 0 0 0-1.479 2.618h1.223a1.836 1.836 0 0 1 3.671 0h1.224A3.061 3.061 0 0 0 7.044 8ZM5.476 6.18a.7.7 0 1 1-.7.7.7.7 0 0 1 .7-.7Z"
        fill="#185edf" //"var(--actionable-icon-color,#185edf)"
      />
    </svg>
  ),
  //"#6a8eff"
  deep_link_command_center_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15.56"
      viewBox="-1 0 17.65 13.55"
    >
      <path
        data-name="carnet (1)"
        d="M13.827 1.224H9.562a1.836 1.836 0 0 0-3.461 0H1.836A1.838 1.838 0 0 0 0 3.059v8.657a1.838 1.838 0 0 0 1.836 1.835h11.993a1.838 1.838 0 0 0 1.834-1.835V3.059a1.838 1.838 0 0 0-1.836-1.835Zm-6 0a.612.612 0 1 1-.612.612.613.613 0 0 1 .616-.612Zm6.608 10.493a.613.613 0 0 1-.611.612H1.836a.613.613 0 0 1-.612-.612V3.059a.613.613 0 0 1 .612-.612H6.1a1.835 1.835 0 0 0 3.461 0h4.266a.613.613 0 0 1 .612.612Zm-4.8-5.782h3.61v1.224H9.636Zm0 2.478h3.61v1.224H9.636ZM7.044 8a1.927 1.927 0 1 0-3.117.025 3.06 3.06 0 0 0-1.479 2.618h1.223a1.836 1.836 0 0 1 3.671 0h1.224A3.061 3.061 0 0 0 7.044 8ZM5.476 6.18a.7.7 0 1 1-.7.7.7.7 0 0 1 .7-.7Z"
        fill="#6a8efff" //"var(--nonactionable-icon-color,#6a8efff)"
      />
    </svg>
  ),
  retweet_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12.6"
      viewBox="0 0 18 12.6"
    >
      <defs>
        <style>
          {`.a { fill: none; stroke:var(--nonactionable-icon-color,var(--locobuzz-primary-text-color, #fff)); stroke-width: 1.62px; }`}
        </style>
      </defs>
      <path
        className="a"
        d="M12.52 11.63H5.13a1.64 1.64 0 0 1-1.64-1.64V2.53"
      />
      <path
        className="a"
        d="m.57 5.44 2.99-2.99 2.99 2.99M5.51 0.81h7.38a1.64 1.64 0 0 1 1.64 1.64v7.38"
      />
      <path className="a" d="m17.44 6.96-2.99 2.99-2.99-2.99" />
    </svg>
  ),

  retweet_white_icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12.6"
      viewBox="0 0 18 12.6"
    >
      <defs>
        <style>
          {`.a { fill: none; stroke: var(--nonactionable-icon-color,var(--locobuzz-primary-text-color, #fff)); stroke-width: 1.62px; }`}
        </style>
      </defs>
      <path
        className="a"
        d="M12.52 11.63H5.13a1.64 1.64 0 0 1-1.64-1.64V2.53"
      />
      <path
        className="a"
        d="m.57 5.44 2.99-2.99 2.99 2.99M5.51 0.81h7.38a1.64 1.64 0 0 1 1.64 1.64v7.38"
      />
      <path className="a" d="m17.44 6.96-2.99 2.99-2.99-2.99" />
    </svg>
  ),
  share_q_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.411" height="17.411">
      <defs>
        <style>
          {
            ".a{fill:none;stroke:var(--nonactionable-icon-color,#3b5175);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <path
        className="a"
        d="M16.661 8.706A7.956 7.956 0 0 0 1.442 5.461M1.155 2.316v3.485M4.64 5.801H1.155M15.969 11.95A7.956 7.956 0 0 1 .75 8.706M16.256 15.095V11.61M12.772 11.61h3.485"
      />
    </svg>
  ),
  share_q_white_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.411" height="17.411">
      <defs>
        <style>
          {
            ".a{fill:none;stroke:var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff));stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"
          }
        </style>
      </defs>
      <path
        className="a"
        d="M16.661 8.706A7.956 7.956 0 0 0 1.442 5.461M1.155 2.316v3.485M4.64 5.801H1.155M15.969 11.95A7.956 7.956 0 0 1 .75 8.706M16.256 15.095V11.61M12.772 11.61h3.485"
      />
    </svg>
  ),
  video_view_white_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  video_view_icon: (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.267">
      <g fill="var(--nonactionable-icon-color,#2d3e5c)">
        <path
          data-name="Path 21796"
          d="M13.974 4.975A7.789 7.789 0 0 0 7 0 7.789 7.789 0 0 0 .028 4.975a.467.467 0 0 0 0 .317A7.789 7.789 0 0 0 7 10.267a7.789 7.789 0 0 0 6.974-4.975.467.467 0 0 0 0-.317ZM7 9.334a6.93 6.93 0 0 1-6.034-4.2A6.929 6.929 0 0 1 7 .934a6.929 6.929 0 0 1 6.034 4.2A6.93 6.93 0 0 1 7 9.334Z"
        />
        <path
          data-name="Path 21797"
          d="M7 2.333a2.8 2.8 0 1 0 2.8 2.8 2.8 2.8 0 0 0-2.8-2.8ZM7 7a1.867 1.867 0 1 1 1.867-1.867A1.867 1.867 0 0 1 7 7Z"
        />
      </g>
    </svg>
  ),
  marked_influencer_blue: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_55343_32922)">
        <path
          d="M19.9709 7.24505C19.9373 7.14085 19.8752 7.04814 19.7916 6.97744C19.708 6.90674 19.6062 6.86088 19.4979 6.84505L13.2979 5.94505L10.5249 0.327048C10.4765 0.228989 10.4017 0.146425 10.3088 0.0886936C10.2159 0.0309621 10.1088 0.000366211 9.99941 0.000366211C9.89006 0.000366211 9.78289 0.0309621 9.69003 0.0886936C9.59716 0.146425 9.5223 0.228989 9.47391 0.327048L6.69991 5.94505L0.499908 6.84505C0.391587 6.86067 0.289805 6.90632 0.206092 6.97681C0.122378 7.04731 0.0600798 7.13984 0.0262527 7.24392C-0.00757446 7.34801 -0.0115782 7.45948 0.014695 7.56572C0.0409682 7.67197 0.0964682 7.76873 0.174908 7.84505L4.66091 12.218L3.59991 18.394C3.58549 18.4782 3.58962 18.5645 3.61203 18.6468C3.63443 18.7292 3.67457 18.8057 3.72962 18.871C3.78467 18.9362 3.85332 18.9886 3.93075 19.0246C4.00819 19.0605 4.09254 19.0791 4.17791 19.079H15.8179C15.9032 19.079 15.9874 19.0603 16.0647 19.0243C16.1421 18.9882 16.2106 18.9358 16.2655 18.8706C16.3205 18.8053 16.3605 18.7289 16.3829 18.6466C16.4052 18.5643 16.4093 18.4781 16.3949 18.394L15.3359 12.219L19.8219 7.84605C19.9004 7.76978 19.9559 7.67305 19.9823 7.56683C20.0086 7.46062 20.0047 7.34915 19.9709 7.24505ZM9.99991 6.60505C10.4882 6.60505 10.9656 6.74985 11.3716 7.02115C11.7776 7.29245 12.0941 7.67805 12.281 8.1292C12.4678 8.58035 12.5167 9.07679 12.4215 9.55573C12.3262 10.0347 12.0911 10.4746 11.7458 10.8199C11.4005 11.1652 10.9605 11.4003 10.4816 11.4956C10.0026 11.5909 9.50621 11.542 9.05506 11.3551C8.60391 11.1682 8.21831 10.8518 7.94701 10.4458C7.67571 10.0397 7.53091 9.56237 7.53091 9.07405C7.5317 8.41947 7.79208 7.79193 8.25494 7.32908C8.71779 6.86622 9.34533 6.60584 9.99991 6.60505ZM5.68791 17.905C5.83025 16.8625 6.3455 15.9068 7.13827 15.2149C7.93105 14.523 8.94766 14.1417 9.99991 14.1417C11.0522 14.1417 12.0688 14.523 12.8615 15.2149C13.6543 15.9068 14.1696 16.8625 14.3119 17.905H5.68791Z"
          fill="#4188E4" //"var(--nonactionable-icon-color,#4188E4)" //"#4188E4"
        />
      </g>
      <defs>
        <clipPath id="clip0_55343_32922">
          <rect width="20" height="19.079" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  marked_influencer_command_center_blue: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="19.079"
      viewBox="0 0 20 19.079"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_157171"
            data-name="Rectangle 157171"
            width="20"
            height="19.079"
            fill="#fff"
          />
        </clipPath>
      </defs>
      <g id="mark_influencer_blue_icon" clipPath="url(#clip-path)">
        <path
          id="Path_73752"
          data-name="Path 73752"
          d="M19.971,7.245a.586.586,0,0,0-.473-.4l-6.2-.9L10.525.327a.586.586,0,0,0-1.051,0L6.7,5.945l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,18.394a.586.586,0,0,0,.578.685h11.64a.586.586,0,0,0,.577-.685l-1.059-6.175,4.486-4.373a.586.586,0,0,0,.149-.6ZM10,6.605a2.472,2.472,0,1,1-1.745.724A2.469,2.469,0,0,1,10,6.605Zm-4.312,11.3a4.352,4.352,0,0,1,8.624,0Z"
          fill="#6a8eff" //"var(--nonactionable-icon-color,#6a8eff)" // "#6a8eff"
        />
      </g>
    </svg>
  ),
  marked_influencer_yellow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19.079"
      viewBox="0 0 20 19.079"
    >
      <g id="influencer" transform="translate(0 -11.795)">
        <g
          id="Group_28061"
          data-name="Group 28061"
          transform="translate(0 11.795)"
        >
          <path
            id="Path_18371"
            data-name="Path 18371"
            d="M19.971,19.04a.586.586,0,0,0-.473-.4l-6.2-.9-2.773-5.618a.586.586,0,0,0-1.051,0L6.7,17.74l-6.2.9a.586.586,0,0,0-.325,1l4.486,4.373L3.6,30.189a.586.586,0,0,0,.578.685H15.818a.586.586,0,0,0,.577-.685l-1.059-6.175,4.486-4.373A.586.586,0,0,0,19.971,19.04ZM10,18.4a2.469,2.469,0,1,1-2.469,2.469A2.472,2.472,0,0,1,10,18.4ZM5.688,29.7a4.352,4.352,0,0,1,8.624,0Z"
            transform="translate(0 -11.795)"
            fill="#deaa0c" //"var(--nonactionable-icon-color,#deaa0c)" //"#deaa0c"
          />
        </g>
      </g>
    </svg>
  ),
  pantip_like_white_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2 15H3.75C2.784 15 2 14.216 2 13.25V6.25H5.62C6.23 6.25 6.803 5.95 7.15 5.48L9.48 2.08C9.95 1.38 10.81 1 11.7 1h.19c.56 0 .99.5.9 1.08L11 6.25h3.25c1.19 0 2.08 1.09 1.86 2.22l-1.08 5.43C14.85 14.23 14.2 15 14.2 15Z"
        fill="none"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 6.25V15"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="1.5"
      />
    </svg>
  ),
  pantip_like_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2 15H3.75C2.784 15 2 14.216 2 13.25V6.25H5.62C6.23 6.25 6.803 5.95 7.15 5.48L9.48 2.08C9.95 1.38 10.81 1 11.7 1h.19c.56 0 .99.5.9 1.08L11 6.25h3.25c1.19 0 2.08 1.09 1.86 2.22l-1.08 5.43C14.85 14.23 14.2 15 14.2 15Z"
        fill="none"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 6.25V15"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="1.5"
      />
    </svg>
  ),
  pantip_comment_white_icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4925 3C16.4925 2.175 15.825 1.5 15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V12C1.5 12.825 2.175 13.5 3 13.5H13.5L16.5 16.5L16.4925 3ZM15 3V12.8775L14.1225 12H3V3H15ZM4.5 9H13.5V10.5H4.5V9ZM4.5 6.75H13.5V8.25H4.5V6.75ZM4.5 4.5H13.5V6H4.5V4.5Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
      />
    </svg>
  ),
  pantip_comment_icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4925 3C16.4925 2.175 15.825 1.5 15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V12C1.5 12.825 2.175 13.5 3 13.5H13.5L16.5 16.5L16.4925 3ZM15 3V12.8775L14.1225 12H3V3H15ZM4.5 9H13.5V10.5H4.5V9ZM4.5 6.75H13.5V8.25H4.5V6.75ZM4.5 4.5H13.5V6H4.5V4.5Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
      />
    </svg>
  ),
  pantip_laugh_white_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4999 17C4.08871 17 0.5 13.4112 0.5 9C0.5 4.58875 4.08871 1 8.4999 1C12.9113 1 16.5 4.58875 16.5 9C16.5 13.4112 12.9113 17 8.4999 17ZM8.4999 1.81691C4.53924 1.81691 1.3169 5.03929 1.3169 9C1.3169 12.9609 4.53924 16.1831 8.4999 16.1831C12.4606 16.1831 15.6831 12.9609 15.6831 9C15.6831 5.03929 12.4606 1.81691 8.4999 1.81691ZM7.15289 7.12804C7.29688 6.95453 7.27295 6.69705 7.09944 6.55285L6.37368 5.95034C5.83061 5.4998 5.04262 5.4998 4.49955 5.95034L3.77379 6.55285C3.60028 6.69705 3.57635 6.95453 3.72034 7.12804C3.86454 7.30175 4.12241 7.32569 4.29553 7.18149L5.02128 6.57898C5.26181 6.37894 5.61142 6.37894 5.85195 6.57898L6.57771 7.18149C6.65389 7.24471 6.74643 7.27563 6.83837 7.27563C6.95564 7.27563 7.07212 7.22537 7.15289 7.12804ZM13.2795 7.12804C13.4235 6.95453 13.3995 6.69705 13.226 6.55285L12.5004 5.95034C11.9572 5.4992 11.169 5.5004 10.6261 5.95034L9.90056 6.55285C9.72705 6.69705 9.70312 6.95453 9.84711 7.12804C9.99111 7.30116 10.2484 7.32529 10.4223 7.18149L11.1479 6.57898C11.3884 6.37954 11.7378 6.37874 11.9787 6.57898L12.7043 7.18149C12.7805 7.24471 12.873 7.27563 12.9647 7.27563C13.082 7.27563 13.1985 7.22537 13.2795 7.12804ZM8.54876 14.649H8.45104C6.09825 14.649 4.18404 12.7347 4.18404 10.3817C4.18404 10.156 4.36692 9.97328 4.59249 9.97328H12.4075C12.6333 9.97328 12.816 10.156 12.816 10.3817C12.816 12.7347 10.9017 14.649 8.54876 14.649ZM5.02507 10.7902C5.2277 12.501 6.6868 13.8321 8.45104 13.8321H8.54876C10.313 13.8321 11.7725 12.501 11.9751 10.7902H5.02507Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_laugh_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4999 17C4.08871 17 0.5 13.4112 0.5 9C0.5 4.58875 4.08871 1 8.4999 1C12.9113 1 16.5 4.58875 16.5 9C16.5 13.4112 12.9113 17 8.4999 17ZM8.4999 1.81691C4.53924 1.81691 1.3169 5.03929 1.3169 9C1.3169 12.9609 4.53924 16.1831 8.4999 16.1831C12.4606 16.1831 15.6831 12.9609 15.6831 9C15.6831 5.03929 12.4606 1.81691 8.4999 1.81691ZM7.15289 7.12804C7.29688 6.95453 7.27295 6.69705 7.09944 6.55285L6.37368 5.95034C5.83061 5.4998 5.04262 5.4998 4.49955 5.95034L3.77379 6.55285C3.60028 6.69705 3.57635 6.95453 3.72034 7.12804C3.86454 7.30175 4.12241 7.32569 4.29553 7.18149L5.02128 6.57898C5.26181 6.37894 5.61142 6.37894 5.85195 6.57898L6.57771 7.18149C6.65389 7.24471 6.74643 7.27563 6.83837 7.27563C6.95564 7.27563 7.07212 7.22537 7.15289 7.12804ZM13.2795 7.12804C13.4235 6.95453 13.3995 6.69705 13.226 6.55285L12.5004 5.95034C11.9572 5.4992 11.169 5.5004 10.6261 5.95034L9.90056 6.55285C9.72705 6.69705 9.70312 6.95453 9.84711 7.12804C9.99111 7.30116 10.2484 7.32529 10.4223 7.18149L11.1479 6.57898C11.3884 6.37954 11.7378 6.37874 11.9787 6.57898L12.7043 7.18149C12.7805 7.24471 12.873 7.27563 12.9647 7.27563C13.082 7.27563 13.1985 7.22537 13.2795 7.12804ZM8.54876 14.649H8.45104C6.09825 14.649 4.18404 12.7347 4.18404 10.3817C4.18404 10.156 4.36692 9.97328 4.59249 9.97328H12.4075C12.6333 9.97328 12.816 10.156 12.816 10.3817C12.816 12.7347 10.9017 14.649 8.54876 14.649ZM5.02507 10.7902C5.2277 12.501 6.6868 13.8321 8.45104 13.8321H8.54876C10.313 13.8321 11.7725 12.501 11.9751 10.7902H5.02507Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_love_icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_81803_39860)">
        <path
          d="M9.70667 3.77832C11.2688 2.21622 13.8018 2.21622 15.3639 3.77832C16.9258 5.34039 16.9258 7.8725 15.3639 9.43457L9.70667 15.0918C9.31612 15.4821 8.68304 15.4822 8.2926 15.0918L2.63635 9.43457C1.07426 7.87247 1.07426 5.34042 2.63635 3.77832C4.19845 2.21622 6.73051 2.21622 8.2926 3.77832C8.683 4.16872 9.31611 4.16847 9.70667 3.77832Z"
          stroke="var(--nonactionable-icon-color,#2d3e5c)"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_81803_39860">
          <rect
            width="18"
            height="18"
            fill="var(--nonactionable-icon-color,#2d3e5c)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  pantip_love_white_icon: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_81803_39860)">
        <path
          d="M9.70667 3.77832C11.2688 2.21622 13.8018 2.21622 15.3639 3.77832C16.9258 5.34039 16.9258 7.8725 15.3639 9.43457L9.70667 15.0918C9.31612 15.4821 8.68304 15.4822 8.2926 15.0918L2.63635 9.43457C1.07426 7.87247 1.07426 5.34042 2.63635 3.77832C4.19845 2.21622 6.73051 2.21622 8.2926 3.77832C8.683 4.16872 9.31611 4.16847 9.70667 3.77832Z"
          stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_81803_39860">
          <rect
            width="18"
            height="18"
            fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  pantip_impress_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.656 4.51562C5.541 4.51562 5.43743 4.5842 5.39243 4.6892L4.96028 5.70206L3.86243 5.79635C3.74814 5.80635 3.65028 5.88349 3.61457 5.99277C3.57885 6.10134 3.61242 6.22134 3.69885 6.29635L4.53029 7.01992L4.281 8.09207C4.25528 8.20421 4.29885 8.31992 4.391 8.38707C4.48385 8.45493 4.60743 8.46064 4.706 8.40207L5.65172 7.83635L6.59602 8.40492C6.69387 8.46421 6.81815 8.45849 6.91174 8.39135C7.00459 8.32421 7.04816 8.20778 7.02245 8.09563L6.77459 7.02277L7.60816 6.30135C7.6953 6.22635 7.72888 6.10706 7.69316 5.99777C7.65816 5.88848 7.56102 5.81063 7.44601 5.80134L6.34815 5.70491L5.91815 4.69062C5.87386 4.58562 5.77029 4.51634 5.656 4.51562ZM5.65457 5.53206L5.88814 6.08419C5.92956 6.18205 6.02099 6.24848 6.126 6.25777L6.72385 6.31062L6.27027 6.70347C6.18956 6.77276 6.15527 6.88062 6.17884 6.98346L6.31313 7.56775L5.79955 7.25775C5.70884 7.20346 5.59598 7.20346 5.50526 7.25704L4.99027 7.56561L5.12598 6.98132C5.14955 6.87847 5.11527 6.77133 5.03598 6.70205L4.58312 6.30848L5.18025 6.25705C5.28597 6.24777 5.37811 6.18134 5.41883 6.08348L5.65457 5.53206Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5 1C4.08491 1 0.5 4.58491 0.5 9C0.5 13.4151 4.08491 17 8.5 17C12.9151 17 16.5 13.4151 16.5 9C16.5 4.58491 12.9151 1 8.5 1ZM8.5 1.57143C12.6057 1.57143 15.9286 4.89431 15.9286 9C15.9286 13.1057 12.6057 16.4286 8.5 16.4286C4.39431 16.4286 1.07143 13.1057 1.07143 9C1.07143 4.89431 4.39431 1.57143 8.5 1.57143Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.64283 10.7139C5.48497 10.7139 5.35712 10.8417 5.35712 10.9996C5.35712 12.4553 6.79854 13.5709 8.50007 13.5709C10.2016 13.5709 11.643 12.4552 11.643 10.9996C11.643 10.8417 11.5152 10.7139 11.3573 10.7139H5.64283ZM6.00211 11.2853H10.9978C10.8142 12.2246 9.81848 12.9996 8.49994 12.9996C7.18139 12.9996 6.1857 12.2246 6.00211 11.2853Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3904 4.51562C11.2754 4.51562 11.1718 4.5842 11.1268 4.6892L10.6947 5.70206L9.5968 5.79635C9.48252 5.80635 9.38465 5.88349 9.34894 5.99277C9.31323 6.10134 9.3468 6.22134 9.43323 6.29635L10.2647 7.01992L10.0154 8.09207C9.98966 8.20421 10.0332 8.31992 10.1254 8.38707C10.2182 8.45493 10.3418 8.46064 10.4404 8.40207L11.3861 7.83635L12.3304 8.40492C12.4282 8.46421 12.5525 8.45849 12.6461 8.39135C12.739 8.32421 12.7825 8.20778 12.7568 8.09563L12.509 7.02277L13.3425 6.30135C13.4297 6.22635 13.4632 6.10706 13.4275 5.99777C13.3925 5.88848 13.2954 5.81063 13.1804 5.80134L12.0825 5.70491L11.6525 4.69062C11.6082 4.58562 11.5047 4.51634 11.3904 4.51562ZM11.3889 5.53206L11.6225 6.08419C11.6639 6.18205 11.7554 6.24848 11.8604 6.25777L12.4582 6.31062L12.0046 6.70347C11.9239 6.77276 11.8896 6.88062 11.9132 6.98346L12.0475 7.56775L11.5339 7.25775C11.4432 7.20346 11.3304 7.20346 11.2396 7.25704L10.7246 7.56561L10.8604 6.98132C10.8839 6.87847 10.8496 6.77133 10.7704 6.70205L10.3175 6.30848L10.9146 6.25705C11.0203 6.24777 11.1125 6.18134 11.1532 6.08348L11.3889 5.53206Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_impress_white_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.656 4.51562C5.541 4.51562 5.43743 4.5842 5.39243 4.6892L4.96028 5.70206L3.86243 5.79635C3.74814 5.80635 3.65028 5.88349 3.61457 5.99277C3.57885 6.10134 3.61242 6.22134 3.69885 6.29635L4.53029 7.01992L4.281 8.09207C4.25528 8.20421 4.29885 8.31992 4.391 8.38707C4.48385 8.45493 4.60743 8.46064 4.706 8.40207L5.65172 7.83635L6.59602 8.40492C6.69387 8.46421 6.81815 8.45849 6.91174 8.39135C7.00459 8.32421 7.04816 8.20778 7.02245 8.09563L6.77459 7.02277L7.60816 6.30135C7.6953 6.22635 7.72888 6.10706 7.69316 5.99777C7.65816 5.88848 7.56102 5.81063 7.44601 5.80134L6.34815 5.70491L5.91815 4.69062C5.87386 4.58562 5.77029 4.51634 5.656 4.51562ZM5.65457 5.53206L5.88814 6.08419C5.92956 6.18205 6.02099 6.24848 6.126 6.25777L6.72385 6.31062L6.27027 6.70347C6.18956 6.77276 6.15527 6.88062 6.17884 6.98346L6.31313 7.56775L5.79955 7.25775C5.70884 7.20346 5.59598 7.20346 5.50526 7.25704L4.99027 7.56561L5.12598 6.98132C5.14955 6.87847 5.11527 6.77133 5.03598 6.70205L4.58312 6.30848L5.18025 6.25705C5.28597 6.24777 5.37811 6.18134 5.41883 6.08348L5.65457 5.53206Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5 1C4.08491 1 0.5 4.58491 0.5 9C0.5 13.4151 4.08491 17 8.5 17C12.9151 17 16.5 13.4151 16.5 9C16.5 4.58491 12.9151 1 8.5 1ZM8.5 1.57143C12.6057 1.57143 15.9286 4.89431 15.9286 9C15.9286 13.1057 12.6057 16.4286 8.5 16.4286C4.39431 16.4286 1.07143 13.1057 1.07143 9C1.07143 4.89431 4.39431 1.57143 8.5 1.57143Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.64283 10.7139C5.48497 10.7139 5.35712 10.8417 5.35712 10.9996C5.35712 12.4553 6.79854 13.5709 8.50007 13.5709C10.2016 13.5709 11.643 12.4552 11.643 10.9996C11.643 10.8417 11.5152 10.7139 11.3573 10.7139H5.64283ZM6.00211 11.2853H10.9978C10.8142 12.2246 9.81848 12.9996 8.49994 12.9996C7.18139 12.9996 6.1857 12.2246 6.00211 11.2853Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.3904 4.51562C11.2754 4.51562 11.1718 4.5842 11.1268 4.6892L10.6947 5.70206L9.5968 5.79635C9.48252 5.80635 9.38465 5.88349 9.34894 5.99277C9.31323 6.10134 9.3468 6.22134 9.43323 6.29635L10.2647 7.01992L10.0154 8.09207C9.98966 8.20421 10.0332 8.31992 10.1254 8.38707C10.2182 8.45493 10.3418 8.46064 10.4404 8.40207L11.3861 7.83635L12.3304 8.40492C12.4282 8.46421 12.5525 8.45849 12.6461 8.39135C12.739 8.32421 12.7825 8.20778 12.7568 8.09563L12.509 7.02277L13.3425 6.30135C13.4297 6.22635 13.4632 6.10706 13.4275 5.99777C13.3925 5.88848 13.2954 5.81063 13.1804 5.80134L12.0825 5.70491L11.6525 4.69062C11.6082 4.58562 11.5047 4.51634 11.3904 4.51562ZM11.3889 5.53206L11.6225 6.08419C11.6639 6.18205 11.7554 6.24848 11.8604 6.25777L12.4582 6.31062L12.0046 6.70347C11.9239 6.77276 11.8896 6.88062 11.9132 6.98346L12.0475 7.56775L11.5339 7.25775C11.4432 7.20346 11.3304 7.20346 11.2396 7.25704L10.7246 7.56561L10.8604 6.98132C10.8839 6.87847 10.8496 6.77133 10.7704 6.70205L10.3175 6.30848L10.9146 6.25705C11.0203 6.24777 11.1125 6.18134 11.1532 6.08348L11.3889 5.53206Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_scary_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1C12.9186 1 16.5 4.40229 16.5 8.6C16.5 10.1424 16.015 11.617 15.122 12.8659C14.9063 13.8848 14.9591 14.6993 15.3846 15.6424C15.4427 15.7713 15.4251 15.9178 15.3422 16.0299L15.2943 16.0838L15.2412 16.1312L15.1093 16.2373C14.9696 16.3435 14.8086 16.449 14.6276 16.5473C14.1075 16.8296 13.5246 17 12.8923 17C12.2601 17 11.6772 16.8296 11.1571 16.5473C10.9761 16.449 10.8151 16.3435 10.6754 16.2373L10.5065 16.0986L10.4893 16.0828C10.4575 16.0526 10.4313 16.0181 10.4114 15.9807C9.79228 16.126 9.15133 16.2 8.5 16.2C7.77307 16.2 7.05905 16.1078 6.37212 15.9282C6.35898 15.9662 6.33927 16.0026 6.31381 16.0358L6.27141 16.0828L6.2543 16.0986L6.0854 16.2373C5.94566 16.3435 5.78469 16.449 5.60364 16.5473C5.08356 16.8296 4.5007 17 3.86842 17C3.23614 17 2.65329 16.8296 2.1332 16.5473C2.0125 16.4818 1.90073 16.4131 1.79822 16.3431L1.65144 16.2373L1.51958 16.1312L1.46646 16.0838L1.41859 16.0299C1.33569 15.9178 1.31802 15.7713 1.37615 15.6424C1.86371 14.5617 1.86193 13.6499 1.52849 12.407L1.48526 12.2544L1.36641 12.042C0.80014 10.9867 0.5 9.81385 0.5 8.6C0.5 4.40229 4.08135 1 8.5 1ZM3.87855 11.3251C3.1088 10.5532 2.27676 10.2778 2.06089 10.4828C1.99335 10.547 1.96072 10.6147 1.97609 10.7758L1.98784 10.8645L2.01493 11.0039L2.08261 11.2791L2.34398 12.2074C2.65375 13.3609 2.71128 14.2947 2.40125 15.2992L2.32914 15.5156L2.26674 15.6768L2.41514 15.7744L2.55101 15.8527C2.95198 16.0704 3.39544 16.2 3.86842 16.2C4.3414 16.2 4.78487 16.0704 5.18584 15.8527C5.28005 15.8016 5.3671 15.7481 5.44637 15.694L5.54926 15.6184L5.54825 15.5333C5.49603 13.9513 4.98001 12.6093 4.16872 11.6424L4.02252 11.4757L3.87855 11.3251ZM12.8822 11.3251L12.7382 11.4757C11.8817 12.41 11.3181 13.7376 11.2226 15.3178L11.2288 15.3304C11.2539 15.4039 11.2553 15.4793 11.2371 15.5492L11.2113 15.6194L11.2014 15.6127C11.3084 15.694 11.4336 15.776 11.5749 15.8527C11.9759 16.0704 12.4194 16.2 12.8923 16.2C13.3653 16.2 13.8088 16.0704 14.2098 15.8527L14.3456 15.7744L14.494 15.6768L14.4316 15.5156C14.0425 14.427 14.0849 13.4433 14.4168 12.2074L14.6781 11.2791L14.7458 11.0039L14.7729 10.8645C14.8099 10.6374 14.7787 10.5577 14.6999 10.4828C14.484 10.2778 13.652 10.5532 12.8822 11.3251ZM8.5 1.8C4.54644 1.8 1.34211 4.84411 1.34211 8.6C1.34211 9.04397 1.38688 9.48155 1.47437 9.90821C2.9497 8.53108 5.99914 11.4245 6.35967 15.0898L6.1039 15.0099C6.8662 15.267 7.67321 15.4 8.5 15.4C9.1482 15.4 9.78414 15.3183 10.3953 15.159L10.4108 14.997C10.8139 11.3683 13.8361 8.5309 15.2953 9.91716L15.4004 10.0213L15.4801 10.1109C15.5976 9.62099 15.6579 9.11485 15.6579 8.6C15.6579 4.84411 12.4536 1.8 8.5 1.8ZM8.5 9C9.70731 9 10.6053 10.2796 10.6053 11.8C10.6053 13.3204 9.70731 14.6 8.5 14.6C7.29269 14.6 6.39474 13.3204 6.39474 11.8C6.39474 10.2796 7.29269 9 8.5 9ZM8.5 9.8C7.84682 9.8 7.23684 10.6692 7.23684 11.8C7.23684 12.9308 7.84682 13.8 8.5 13.8C9.15318 13.8 9.76316 12.9308 9.76316 11.8C9.76316 10.6692 9.15318 9.8 8.5 9.8ZM3.03618 5.64713C3.80679 4.37308 5.36771 3.82505 6.54166 4.47201C7.71425 5.11823 7.99699 6.6798 7.22697 7.95287C6.45637 9.22692 4.89545 9.77495 3.7215 9.12799C2.54891 8.48177 2.26617 6.9202 3.03618 5.64713ZM13.9638 5.64713C14.7338 6.9202 14.4511 8.48177 13.2785 9.12799C12.1046 9.77495 10.5436 9.22692 9.77303 7.95287C9.00301 6.6798 9.28575 5.11823 10.4583 4.47201C11.6323 3.82505 13.1932 4.37308 13.9638 5.64713ZM6.1191 5.16401C5.38163 4.75758 4.32 5.13031 3.76633 6.0457C3.21207 6.96207 3.40522 8.02882 4.14406 8.43599C4.88153 8.84242 5.94315 8.46969 6.49682 7.5543C7.05109 6.63793 6.85794 5.57118 6.1191 5.16401ZM10.8809 5.16401C10.1421 5.57118 9.94891 6.63793 10.5032 7.5543C11.0568 8.46969 12.1185 8.84242 12.8559 8.43599C13.5948 8.02882 13.7879 6.96207 13.2337 6.0457C12.68 5.13031 11.6184 4.75758 10.8809 5.16401Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.4"
      />
    </svg>
  ),
  pantip_scary_white_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1C12.9186 1 16.5 4.40229 16.5 8.6C16.5 10.1424 16.015 11.617 15.122 12.8659C14.9063 13.8848 14.9591 14.6993 15.3846 15.6424C15.4427 15.7713 15.4251 15.9178 15.3422 16.0299L15.2943 16.0838L15.2412 16.1312L15.1093 16.2373C14.9696 16.3435 14.8086 16.449 14.6276 16.5473C14.1075 16.8296 13.5246 17 12.8923 17C12.2601 17 11.6772 16.8296 11.1571 16.5473C10.9761 16.449 10.8151 16.3435 10.6754 16.2373L10.5065 16.0986L10.4893 16.0828C10.4575 16.0526 10.4313 16.0181 10.4114 15.9807C9.79228 16.126 9.15133 16.2 8.5 16.2C7.77307 16.2 7.05905 16.1078 6.37212 15.9282C6.35898 15.9662 6.33927 16.0026 6.31381 16.0358L6.27141 16.0828L6.2543 16.0986L6.0854 16.2373C5.94566 16.3435 5.78469 16.449 5.60364 16.5473C5.08356 16.8296 4.5007 17 3.86842 17C3.23614 17 2.65329 16.8296 2.1332 16.5473C2.0125 16.4818 1.90073 16.4131 1.79822 16.3431L1.65144 16.2373L1.51958 16.1312L1.46646 16.0838L1.41859 16.0299C1.33569 15.9178 1.31802 15.7713 1.37615 15.6424C1.86371 14.5617 1.86193 13.6499 1.52849 12.407L1.48526 12.2544L1.36641 12.042C0.80014 10.9867 0.5 9.81385 0.5 8.6C0.5 4.40229 4.08135 1 8.5 1ZM3.87855 11.3251C3.1088 10.5532 2.27676 10.2778 2.06089 10.4828C1.99335 10.547 1.96072 10.6147 1.97609 10.7758L1.98784 10.8645L2.01493 11.0039L2.08261 11.2791L2.34398 12.2074C2.65375 13.3609 2.71128 14.2947 2.40125 15.2992L2.32914 15.5156L2.26674 15.6768L2.41514 15.7744L2.55101 15.8527C2.95198 16.0704 3.39544 16.2 3.86842 16.2C4.3414 16.2 4.78487 16.0704 5.18584 15.8527C5.28005 15.8016 5.3671 15.7481 5.44637 15.694L5.54926 15.6184L5.54825 15.5333C5.49603 13.9513 4.98001 12.6093 4.16872 11.6424L4.02252 11.4757L3.87855 11.3251ZM12.8822 11.3251L12.7382 11.4757C11.8817 12.41 11.3181 13.7376 11.2226 15.3178L11.2288 15.3304C11.2539 15.4039 11.2553 15.4793 11.2371 15.5492L11.2113 15.6194L11.2014 15.6127C11.3084 15.694 11.4336 15.776 11.5749 15.8527C11.9759 16.0704 12.4194 16.2 12.8923 16.2C13.3653 16.2 13.8088 16.0704 14.2098 15.8527L14.3456 15.7744L14.494 15.6768L14.4316 15.5156C14.0425 14.427 14.0849 13.4433 14.4168 12.2074L14.6781 11.2791L14.7458 11.0039L14.7729 10.8645C14.8099 10.6374 14.7787 10.5577 14.6999 10.4828C14.484 10.2778 13.652 10.5532 12.8822 11.3251ZM8.5 1.8C4.54644 1.8 1.34211 4.84411 1.34211 8.6C1.34211 9.04397 1.38688 9.48155 1.47437 9.90821C2.9497 8.53108 5.99914 11.4245 6.35967 15.0898L6.1039 15.0099C6.8662 15.267 7.67321 15.4 8.5 15.4C9.1482 15.4 9.78414 15.3183 10.3953 15.159L10.4108 14.997C10.8139 11.3683 13.8361 8.5309 15.2953 9.91716L15.4004 10.0213L15.4801 10.1109C15.5976 9.62099 15.6579 9.11485 15.6579 8.6C15.6579 4.84411 12.4536 1.8 8.5 1.8ZM8.5 9C9.70731 9 10.6053 10.2796 10.6053 11.8C10.6053 13.3204 9.70731 14.6 8.5 14.6C7.29269 14.6 6.39474 13.3204 6.39474 11.8C6.39474 10.2796 7.29269 9 8.5 9ZM8.5 9.8C7.84682 9.8 7.23684 10.6692 7.23684 11.8C7.23684 12.9308 7.84682 13.8 8.5 13.8C9.15318 13.8 9.76316 12.9308 9.76316 11.8C9.76316 10.6692 9.15318 9.8 8.5 9.8ZM3.03618 5.64713C3.80679 4.37308 5.36771 3.82505 6.54166 4.47201C7.71425 5.11823 7.99699 6.6798 7.22697 7.95287C6.45637 9.22692 4.89545 9.77495 3.7215 9.12799C2.54891 8.48177 2.26617 6.9202 3.03618 5.64713ZM13.9638 5.64713C14.7338 6.9202 14.4511 8.48177 13.2785 9.12799C12.1046 9.77495 10.5436 9.22692 9.77303 7.95287C9.00301 6.6798 9.28575 5.11823 10.4583 4.47201C11.6323 3.82505 13.1932 4.37308 13.9638 5.64713ZM6.1191 5.16401C5.38163 4.75758 4.32 5.13031 3.76633 6.0457C3.21207 6.96207 3.40522 8.02882 4.14406 8.43599C4.88153 8.84242 5.94315 8.46969 6.49682 7.5543C7.05109 6.63793 6.85794 5.57118 6.1191 5.16401ZM10.8809 5.16401C10.1421 5.57118 9.94891 6.63793 10.5032 7.5543C11.0568 8.46969 12.1185 8.84242 12.8559 8.43599C13.5948 8.02882 13.7879 6.96207 13.2337 6.0457C12.68 5.13031 11.6184 4.75758 10.8809 5.16401Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.4"
      />
    </svg>
  ),
  pantip_wow_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1C6.37824 1 4.34319 1.84311 2.84304 3.34304C1.34289 4.84297 0.5 6.87824 0.5 9C0.5 11.1218 1.34311 13.1568 2.84304 14.657C4.34297 16.1571 6.37824 17 8.5 17C10.6218 17 12.6568 16.1569 14.157 14.657C15.6571 13.157 16.5 11.1218 16.5 9C16.4956 6.87974 15.6518 4.84676 14.1525 3.34754C12.6532 1.84827 10.6203 1.0045 8.5 1ZM8.5 16.2177C6.58582 16.2177 4.75009 15.4575 3.39595 14.104C2.04259 12.7499 1.28226 10.9142 1.28226 9C1.28226 7.08582 2.04253 5.25009 3.39595 3.89595C4.75005 2.54259 6.58582 1.78226 8.5 1.78226C10.4142 1.78226 12.2499 2.54253 13.604 3.89595C14.9574 5.25005 15.7177 7.08582 15.7177 9C15.7141 10.9127 14.9523 12.7463 13.599 14.099C12.2463 15.4523 10.4127 16.2142 8.5 16.2177ZM8.5 8.41349C7.15469 8.41349 6.06237 9.88196 6.06237 11.6863C6.06237 13.4907 7.15474 14.9591 8.5 14.9591C9.84526 14.9591 10.9376 13.4965 10.9376 11.6863C10.9376 9.87611 9.84526 8.41349 8.5 8.41349ZM8.5 14.1767C7.60265 14.1767 6.84384 13.0367 6.84384 11.6861C6.84384 10.335 7.60265 9.19557 8.5 9.19557C9.39735 9.19557 10.1562 10.3371 10.1562 11.6861C10.1562 13.0352 9.39735 14.1767 8.5 14.1767ZM7.2566 6.84971C7.2544 6.2456 6.88857 5.70308 6.33064 5.47362C5.77199 5.24414 5.1305 5.37391 4.70454 5.80133C4.27859 6.22874 4.15175 6.87098 4.38343 7.42817C4.61511 7.98537 5.15909 8.34898 5.7632 8.34898C6.15983 8.34898 6.54106 8.19063 6.82112 7.90909C7.10118 7.6283 7.25806 7.24634 7.2566 6.84971ZM5.7632 7.56672C5.47582 7.56672 5.21627 7.39443 5.10631 7.12904C4.99561 6.86364 5.05572 6.55792 5.25807 6.35412C5.45968 6.15031 5.7654 6.08798 6.03153 6.19649C6.29767 6.30426 6.47215 6.56232 6.47435 6.84972C6.47582 7.03887 6.40104 7.22143 6.2676 7.35559C6.13417 7.49048 5.95235 7.56672 5.7632 7.56672ZM11.2368 5.36369C10.632 5.36369 10.0872 5.72879 9.85629 6.28745C9.62535 6.84684 9.75512 7.48979 10.184 7.91648C10.6121 8.34316 11.2558 8.46854 11.8138 8.2354C12.3717 8.00153 12.7339 7.4546 12.7309 6.84977C12.7265 6.02792 12.0586 5.36369 11.2368 5.36369ZM11.2368 7.56672C10.9494 7.56672 10.6906 7.39443 10.5799 7.12904C10.4699 6.86364 10.5293 6.55792 10.7317 6.35412C10.934 6.15031 11.239 6.08798 11.5051 6.19649C11.7713 6.30426 11.9465 6.56232 11.9487 6.84972C11.9494 7.03887 11.8754 7.22143 11.7419 7.35559C11.6085 7.49048 11.4267 7.56672 11.2368 7.56672Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_wow_white_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1C6.37824 1 4.34319 1.84311 2.84304 3.34304C1.34289 4.84297 0.5 6.87824 0.5 9C0.5 11.1218 1.34311 13.1568 2.84304 14.657C4.34297 16.1571 6.37824 17 8.5 17C10.6218 17 12.6568 16.1569 14.157 14.657C15.6571 13.157 16.5 11.1218 16.5 9C16.4956 6.87974 15.6518 4.84676 14.1525 3.34754C12.6532 1.84827 10.6203 1.0045 8.5 1ZM8.5 16.2177C6.58582 16.2177 4.75009 15.4575 3.39595 14.104C2.04259 12.7499 1.28226 10.9142 1.28226 9C1.28226 7.08582 2.04253 5.25009 3.39595 3.89595C4.75005 2.54259 6.58582 1.78226 8.5 1.78226C10.4142 1.78226 12.2499 2.54253 13.604 3.89595C14.9574 5.25005 15.7177 7.08582 15.7177 9C15.7141 10.9127 14.9523 12.7463 13.599 14.099C12.2463 15.4523 10.4127 16.2142 8.5 16.2177ZM8.5 8.41349C7.15469 8.41349 6.06237 9.88196 6.06237 11.6863C6.06237 13.4907 7.15474 14.9591 8.5 14.9591C9.84526 14.9591 10.9376 13.4965 10.9376 11.6863C10.9376 9.87611 9.84526 8.41349 8.5 8.41349ZM8.5 14.1767C7.60265 14.1767 6.84384 13.0367 6.84384 11.6861C6.84384 10.335 7.60265 9.19557 8.5 9.19557C9.39735 9.19557 10.1562 10.3371 10.1562 11.6861C10.1562 13.0352 9.39735 14.1767 8.5 14.1767ZM7.2566 6.84971C7.2544 6.2456 6.88857 5.70308 6.33064 5.47362C5.77199 5.24414 5.1305 5.37391 4.70454 5.80133C4.27859 6.22874 4.15175 6.87098 4.38343 7.42817C4.61511 7.98537 5.15909 8.34898 5.7632 8.34898C6.15983 8.34898 6.54106 8.19063 6.82112 7.90909C7.10118 7.6283 7.25806 7.24634 7.2566 6.84971ZM5.7632 7.56672C5.47582 7.56672 5.21627 7.39443 5.10631 7.12904C4.99561 6.86364 5.05572 6.55792 5.25807 6.35412C5.45968 6.15031 5.7654 6.08798 6.03153 6.19649C6.29767 6.30426 6.47215 6.56232 6.47435 6.84972C6.47582 7.03887 6.40104 7.22143 6.2676 7.35559C6.13417 7.49048 5.95235 7.56672 5.7632 7.56672ZM11.2368 5.36369C10.632 5.36369 10.0872 5.72879 9.85629 6.28745C9.62535 6.84684 9.75512 7.48979 10.184 7.91648C10.6121 8.34316 11.2558 8.46854 11.8138 8.2354C12.3717 8.00153 12.7339 7.4546 12.7309 6.84977C12.7265 6.02792 12.0586 5.36369 11.2368 5.36369ZM11.2368 7.56672C10.9494 7.56672 10.6906 7.39443 10.5799 7.12904C10.4699 6.86364 10.5293 6.55792 10.7317 6.35412C10.934 6.15031 11.239 6.08798 11.5051 6.19649C11.7713 6.30426 11.9465 6.56232 11.9487 6.84972C11.9494 7.03887 11.8754 7.22143 11.7419 7.35559C11.6085 7.49048 11.4267 7.56672 11.2368 7.56672Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_point_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1C6.37824 1 4.34319 1.84311 2.84304 3.34304C1.34289 4.84297 0.5 6.87824 0.5 9C0.5 11.1218 1.34311 13.1568 2.84304 14.657C4.34297 16.1571 6.37824 17 8.5 17C10.6218 17 12.6568 16.1569 14.157 14.657C15.6571 13.157 16.5 11.1218 16.5 9C16.4956 6.87974 15.6518 4.84676 14.1525 3.34754C12.6532 1.84827 10.6203 1.0045 8.5 1ZM8.5 16.2177C6.58582 16.2177 4.75009 15.4575 3.39595 14.104C2.04259 12.7499 1.28226 10.9142 1.28226 9C1.28226 7.08582 2.04253 5.25009 3.39595 3.89595C4.75005 2.54259 6.58582 1.78226 8.5 1.78226C10.4142 1.78226 12.2499 2.54253 13.604 3.89595C14.9574 5.25005 15.7177 7.08582 15.7177 9C15.7141 10.9127 14.9523 12.7463 13.599 14.099C12.2463 15.4523 10.4127 16.2142 8.5 16.2177Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
      <path
        d="M9.4001 7.65039H7.6001V8.55039H9.4001V7.65039Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
      <path
        d="M8.5001 3.59961C6.9701 3.59961 5.7101 4.13961 4.7201 5.21961C3.7301 6.29961 3.1001 7.46961 3.1001 8.99961C3.1001 10.5296 3.6401 11.7896 4.7201 12.7796C5.8001 13.7696 6.9701 14.3996 8.5001 14.3996C10.0301 14.3996 11.2901 13.8596 12.2801 12.7796C13.2701 11.6996 13.9001 10.5296 13.9001 8.99961C13.9001 7.46961 13.3601 6.20961 12.2801 5.21961C11.2001 4.22961 10.0301 3.59961 8.5001 3.59961ZM10.7501 8.54961C10.7501 8.90961 10.5701 9.26961 10.3001 9.44961C10.0301 9.62961 9.7601 9.89961 9.4001 9.89961H7.6001V11.6996H6.2501V6.29961H9.4001C9.7601 6.29961 10.1201 6.47961 10.3001 6.74961C10.4801 7.01961 10.7501 7.28961 10.7501 7.64961V8.54961Z"
        fill="var(--nonactionable-icon-color,#2d3e5c)"
        stroke="var(--nonactionable-icon-color,#2d3e5c)"
        stroke-width="0.5"
      />
    </svg>
  ),
  pantip_point_white_icon: (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1C6.37824 1 4.34319 1.84311 2.84304 3.34304C1.34289 4.84297 0.5 6.87824 0.5 9C0.5 11.1218 1.34311 13.1568 2.84304 14.657C4.34297 16.1571 6.37824 17 8.5 17C10.6218 17 12.6568 16.1569 14.157 14.657C15.6571 13.157 16.5 11.1218 16.5 9C16.4956 6.87974 15.6518 4.84676 14.1525 3.34754C12.6532 1.84827 10.6203 1.0045 8.5 1ZM8.5 16.2177C6.58582 16.2177 4.75009 15.4575 3.39595 14.104C2.04259 12.7499 1.28226 10.9142 1.28226 9C1.28226 7.08582 2.04253 5.25009 3.39595 3.89595C4.75005 2.54259 6.58582 1.78226 8.5 1.78226C10.4142 1.78226 12.2499 2.54253 13.604 3.89595C14.9574 5.25005 15.7177 7.08582 15.7177 9C15.7141 10.9127 14.9523 12.7463 13.599 14.099C12.2463 15.4523 10.4127 16.2142 8.5 16.2177Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
      <path
        d="M9.4001 7.65039H7.6001V8.55039H9.4001V7.65039Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
      <path
        d="M8.5001 3.59961C6.9701 3.59961 5.7101 4.13961 4.7201 5.21961C3.7301 6.29961 3.1001 7.46961 3.1001 8.99961C3.1001 10.5296 3.6401 11.7896 4.7201 12.7796C5.8001 13.7696 6.9701 14.3996 8.5001 14.3996C10.0301 14.3996 11.2901 13.8596 12.2801 12.7796C13.2701 11.6996 13.9001 10.5296 13.9001 8.99961C13.9001 7.46961 13.3601 6.20961 12.2801 5.21961C11.2001 4.22961 10.0301 3.59961 8.5001 3.59961ZM10.7501 8.54961C10.7501 8.90961 10.5701 9.26961 10.3001 9.44961C10.0301 9.62961 9.7601 9.89961 9.4001 9.89961H7.6001V11.6996H6.2501V6.29961H9.4001C9.7601 6.29961 10.1201 6.47961 10.3001 6.74961C10.4801 7.01961 10.7501 7.28961 10.7501 7.64961V8.54961Z"
        fill="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke="var(--nonactionable-icon-color, var(--locobuzz-primary-text-color, #fff))"
        stroke-width="0.5"
      />
    </svg>
  ),
};

export const getDynamicChannelIcon = (status = null) => {
  switch (status) {
    case "facebook_like_white":
    case "facebook_like":
    case "upvote_white":
    case "upvote":
    case "facebook_share":
    case "facebook_share_white":
    case "instagram_share":
    case "instagram_share_white":
    case "youtube_share":
    case "youtube_share_white":
    case "video_view":
    case "video_view_white":
    case "like_icon":
    case "like_white_icon":
    case "pantip_like_white_icon":
    case "pantip_like_icon":
    case "pantip_comment_white_icon":
    case "pantip_comment_icon":
    case "pantip_wow_white_icon":
    case "pantip_wow_icon":
    case "pantip_scary_white_icon":
    case "pantip_scary_icon":
    case "pantip_love_white_icon":
    case "pantip_love_icon":
    case "pantip_impress_white_icon":
    case "pantip_impress_icon":
    case "pantip_laugh_white_icon":
    case "pantip_laugh_icon":
    case "pantip_point_white_icon":
    case "pantip_point_icon":
    case "comment_icon":
    case "comment_white_icon":
    case "postClick_white":
    case "postClick_black":
    case "delete_post":
    case "hide_post":
    case "deep_link_icon": // actionable
    case "deep_link_command_center_icon": // actionable
    case "retweet_white_icon":
    case "retweet_icon":
    case "share_q_white_icon":
    case "share_q_icon":
    case "video_view_white_icon":
    case "video_view_icon":
    case "marked_influencer_yellow": // harcode yellow
    case "marked_influencer_blue": // hardcode blue
    case "marked_influencer_command_center_blue": // hardcoded blue
      return DynamicChannelIcon?.[status];
    default:
      return "";
  }
};
